var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMugSaucer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 32H112C103.199 32 96 39.199 96 48V288C96 341.02 138.98 384 192 384H384C437.02 384 480 341.02 480 288H506.381C573.209 288 632.955 239.219 639.385 172.701C646.762 96.385 586.814 32 512 32ZM432 288C432 314.4 410.4 336 384 336H192C165.6 336 144 314.4 144 288V80H432V288ZM512 240H480V80H512C556.125 80 592 115.875 592 160S556.125 240 512 240ZM552 432H24C10.746 432 0 442.744 0 456C0 469.254 10.746 480 24 480H552C565.254 480 576 469.254 576 456C576 442.744 565.254 432 552 432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMugSaucer);
export default __webpack_public_path__ + "static/media/mug-saucer.39dd7bea1a4be3ce14293291cc9a783f.svg";
export { ForwardRef as ReactComponent };